import classNames from 'classnames';
import React, { useState } from 'react';
import {
  FaRegThumbsDown,
  FaRegThumbsUp,
  FaThumbsDown,
  FaThumbsUp,
} from 'react-icons/fa';
import styled from 'styled-components';

import { uiHelpers } from '../../helpers';
import { useFavStocks } from '../../hooks/useFavoriteStocks';
import { usePreferences } from '../../hooks/usePreferences';
import { Category } from '../../py-generated/datalouder/stock/types';
import LoadingImage from '../general/LoadingImage';
import { useFavorite } from './useFavorite';

const Styles = styled.span`
  .second-option * {
    margin-left: 5px;
  }

  .hide-by-default * {
    display: none;
  }

  &:hover .hide-by-default * {
    display: unset;
  }
`;

interface LikeButtonProps {
  category: Category;
  ticker: string;
  showBothButtons?: boolean;
}

const LikeButton: React.FC<LikeButtonProps> = ({
  category,
  ticker,
  showBothButtons,
}) => {
  const { loading } = useFavStocks();

  const { graphColorStyle } = usePreferences();

  const [updating, setUpdating] = useState(false);
  const [isLike, toggleLike, isUnlike, toggleUnlike] = useFavorite();

  if (loading || updating) {
    return <LoadingImage loading />;
  }

  const handleLikeClick = () => {
    setUpdating(true);
    toggleLike(category, ticker, () => setUpdating(false));
  };

  const handleUnlikeClick = () => {
    setUpdating(true);
    toggleUnlike(category, ticker, () => setUpdating(false));
  };

  const likeButton = () => {
    return isLike(category, ticker) ? (
      <FaThumbsUp
        style={{
          cursor: 'pointer',
          color: uiHelpers.candleStickColorMap(graphColorStyle).up,
        }}
        onClick={handleLikeClick}
      />
    ) : (
      <FaRegThumbsUp
        style={{ cursor: 'pointer', color: '#888' }}
        onClick={handleLikeClick}
      />
    );
  };

  const unlikeButton = () => {
    return isUnlike(category, ticker) ? (
      <FaThumbsDown
        style={{
          cursor: 'pointer',
          color: uiHelpers.candleStickColorMap(graphColorStyle).down,
        }}
        onClick={handleUnlikeClick}
      />
    ) : (
      <FaRegThumbsDown
        style={{ cursor: 'pointer', color: '#888' }}
        onClick={handleUnlikeClick}
      />
    );
  };

  return (
    <Styles>
      {isUnlike(category, ticker) ? unlikeButton() : likeButton()}
      <span
        className={classNames('second-option', {
          'hide-by-default': !showBothButtons,
        })}
      >
        {isUnlike(category, ticker) ? likeButton() : unlikeButton()}
      </span>
    </Styles>
  );
};

export default LikeButton;
